"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderSubmit2FAModelCMS = void 0;
var OrderSubmit2FAModelCMS = /** @class */ (function () {
    function OrderSubmit2FAModelCMS() {
        this.headingLabel = 'Let\'s make sure it\'s you';
        this.panelDescriptionLabel = 'To keep your account safe, we\'ll text you a code to confirm your identity.';
        this.panel2PinOptionLabel = ' To complete your order, we’ll send you 2 temporary verification codes.';
        this.textCodeCTNSendInfoLabel = 'Text the code to: [[code]]';
        this.textCodeEmailPlaceHolderTxt = 'Enter email code';
        this.textCodeSMSPlaceHolderTxt = 'Enter text code';
        this.textCodeEmailSendInfoLabel = 'Email the code to: [[code]]';
        this.textCodeTxtBoxLabel = 'Enter code';
        this.smsCodeTxtBoxLabel = 'Text code:';
        this.emailCodeTxtBoxLabel = 'Email code:';
        this.resendCodeLinkTxt = 'I already have a code';
        this.sendAnotherCodeLinkTxt = 'Request another verification code';
        this.sendNewCodeLinkTxt = 'Get a new code';
        this.sendPinSystemErrorMsg = 'Uh-oh! Looks like we\'re having trouble sending you a verification code.' +
            ' Go ahead and submit your order. If we hit a snag later, we\'ll contact you. ';
        this.submitOrderCTALabel = 'Submit order';
        this.confirmCTALabel = 'Submit';
        this.sendCodeCTALabel = 'Send code';
        this.safeGuardDesktopCTALabel = 'Go to myAT&T';
        this.safeGuardMobileCTALabel = 'Unlock now';
        this.safeGuardMobileHeadingLabel = 'Before you proceed.';
        this.safeGuardMobileSubHeadingLabel = "Your Wireless account is lock. You can still browse and add product\n                                    to cart. To proceed to checkout, you will have to unlock your account.";
        this.safeGuardMobileStepHeadingLabel = 'Step to unlock it:';
        this.safeGuardMobileStepLabel1 = '1. Log in to myAT&T App';
        this.safeGuardMobileStepLabel2 = '2. In your dashboard, find';
        this.safeGuardMobileStepLabel = '\"Subscription panel\"';
        this.safeGuardMobileStepLabel3 = '3. Switch the toggle to Unlock';
        this.safeGuardMobileStepLabel4 = '4. Confirm and you are ready to go!';
        this.safeGuardDesktopHeadingLabel = 'Your account is locked';
        this.safeGuardDesktopSubHeadingLabel = "You have your AT&T Wireless Account Lock feature turned on.\n                                       To place an order today, please go to your myAT&T account to turn\n                                       this feature off.";
        this.inputErrorTxt = 'Restrict to alpha numberic char only';
        this.multipleOptionTxtLabel = 'How do you want to receive the access code?';
        this.oneOfTheCodeWrongErrorMsg = "One of the codes you entered isn\u2019t working. Try again\n                                or request new temporary codes.";
        this.codeWrongErrorMsg = 'Hmm... That code doesn\'t match. Try again or request a new code.';
        this.sendSMSErrorMsg = "Sms send failed, please try again";
        this.hardStopCTOMsg = "Looks like you\u2019ll need to speak to one of our service reps to complete your order.\n                    Please call us at 866.662.4548.";
        this.hardStopNum = "866.662.4548";
        this.ctnpulldownMenuPlaceHolderTxt = 'Select a Wireless number';
        this.emailRadioButtonLabel = 'Email';
        this.smsRadioButtonLabel = 'Text';
        this.gotCodeLabel = 'Got your code?';
        this.textCodeSelectionLabel = 'Which number should we use?';
        this.wrongCodeErrLabel = 'This code is incorrect.';
        this.headsUpText = "<b>Heads up:</b> After you place your order, you must upload your ID within 24 hours, or your order will be canceled. We'll process your order once we make sure it\u2019s you.";
        this.codeSentLabel = 'We sent it to [x]. It may take a few minutes to get to you.';
        this.verifyAndSubmitLabel = 'Verify and submit order';
        this.authIdVerifyLabel = 'We need to verify who you are';
        this.authIdEmailLabel = "We'll email a link to <b>[[email]]</b>. You\u2019ll need to use a mobile device to scan and upload your driver\u2019s license, state ID, or passport. After we make sure it\u2019s you, we'll process your order.";
        this.authIdcheckboxLabel = 'I also want a one-time text with the link';
        this.authIdSubmitLabel = 'OK, place my order';
        this.simSwapErrorMessage = "Looks like there was a recent change to that number. We can't send a text to it right now. Please choose a different number and try again.";
        this.cancelButtonLabel = "Cancel my order";
        this.simCtoErrorMessage = "Incorrect code. Check code again and re-enter or get a new one.";
    }
    return OrderSubmit2FAModelCMS;
}());
exports.OrderSubmit2FAModelCMS = OrderSubmit2FAModelCMS;
//# sourceMappingURL=OrderSubmit2FAModel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/OrderSubmit2FAModel/OrderSubmit2FAModel.cms.js
// module id = 2042
// module chunks = 8